import { render, staticRenderFns } from "./ProductTimer.vue?vue&type=template&id=4dffca32"
import script from "./ProductTimer.vue?vue&type=script&lang=js"
export * from "./ProductTimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports